export default "__VITE_ASSET__Ce$uM6PX__"